import request from '@/utils/request'

export function loginPassWord(data) { // 账密登录
  return request({
    url: '/website.sdk/loginPass',
    method: 'post',
    data,
  })
}

export function loginPhone(data) { // 手机验证码登录
  return request({
    url: '/website.sdk/loginSms',
    method: 'post',
    data,
  })
}

export function getSendCode(data) { // 获取验证码
  return request({
    url: 'website.sdk/sendSms',
    method: 'post',
    data,
  })
}

export function getUserInformation(data) { // 获取用户信息
  return request({
    url: '/mall.api.login/getState',
    method: 'post',
    data,
  })
}

export function logoutUser(data) { // 用户注销
  return request({
    url: '/mall.api.login/logout',
    method: 'post',
    data,
  })
}